import { defineMessages } from "react-intl";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import CommonFieldName from "./CommonFieldName";
import DateTimeField from "./impl/DateTimeField";
import FieldModel from "./impl/FieldModel";
import { createField } from "./impl/fieldModelUtil";
import NameField from "./impl/NameField";
import UserField from "./impl/UserField";

export enum TerritoryFieldName {
  NAME = CommonFieldName.NAME,
  COLOR = CommonFieldName.COLOR,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  USER = CommonFieldName.USER,
}

const displayNames = defineMessages<TerritoryFieldName>({
  [TerritoryFieldName.COLOR]: {
    id: "territory.field.color",
    defaultMessage: "Color",
    description: "Color field of territory",
  },
  [TerritoryFieldName.NAME]: {
    id: "territory.field.name",
    defaultMessage: "Name",
    description: "Name field of territory",
  },
  [TerritoryFieldName.UPDATED_AT]: {
    id: "territory.field.updatedAt",
    defaultMessage: "Date Last Modified",
    description: "Modified At field of territory",
  },
  [TerritoryFieldName.USER]: {
    id: "territory.field.user",
    defaultMessage: "Creator",
    description: "Creator of territory",
  },
});

const territoryFieldModel = new FieldModel(
  [
    new NameField({
      displayName: displayNames[TerritoryFieldName.NAME],
      name: TerritoryFieldName.NAME,
    }),
    {
      customGridProperties: {
        cellRenderer: "colorCellRenderer",
      },
      displayName: displayNames[TerritoryFieldName.COLOR],
      features: [FieldFeature.SORTABLE, FieldFeature.FILTERABLE],
      name: TerritoryFieldName.COLOR,
      type: FieldType.STRING,
    },
    new DateTimeField({
      displayName: displayNames[TerritoryFieldName.UPDATED_AT],
      name: TerritoryFieldName.UPDATED_AT,
    }),
    new UserField({
      displayName: displayNames[TerritoryFieldName.USER],
      features: [FieldFeature.FILTERABLE],
      name: TerritoryFieldName.USER,
      platformFilterNames: ["userId", "user.id"],
      platformName: "userId",
    }),
  ].map(createField)
);

export default territoryFieldModel;
